var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticClass:"h-100 w-100 p-abs c-pointer",attrs:{"multiple":"","type":"file","name":"file","accept":_vm.mimeTypes},on:{"change":function($event){return _vm.$emit('upload', $event.target.files)}}})}
var staticRenderFns = []

export { render, staticRenderFns }